module.exports = (__webpack_require__(5275))(3345);